import React, { Component } from "react";
import FileUploader from "../../../Utilities/Helpers/FileUploader/FileUploader";

import {
    Paper,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    IconButton,
    ListItemSecondaryAction,
    Grid,
} from "@material-ui/core";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";
import DrawIcon from "mdi-react/DrawIcon";

import {
    Delete as DeleteIcon,
    RemoveRedEye as ViewIcon,
} from "@material-ui/icons";

import styled from "styled-components";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getAllFiles, uploadFile, redirectTo, goToLink } from "./actions";
import { connect } from "react-redux";
import _ from "lodash";
import { noSig } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";

const SignaturePaper = styled(Paper)`
    width: 75vw;
    position: absolute;
    left: -75%;
    @media print {
        width: 100vw;
        position: absolute;
        left: 0%;
    }
`;
const ModalFooterForPrint = styled(ModalFooter)`
    @media print {
        visibility: hidden;
    }
`;
class JobPackMethodStatement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            profile: props.profile,
            edit: props.edit,

            viewMRSASignaturesModal: false,

            deleteModal: false,
            signatureModal: false,

            addFileModal: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }

    render() {
        const {
            profile,

            deleteModal,
            signatureModal,
            edit,
        } = this.state;

        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label="Method Statements & TM Plans"
            >
                <List dense={false} style={{ padding: 12 }}>
                    {profile.job_pack_method_statement &&
                        profile.job_pack_method_statement.map((e, i) => {
                            return (
                                <ListItem>
                                    {" "}
                                    <ListItemText primary={e.file} />
                                    <ListItemSecondaryAction>
                                        {!this.state.edit && !this.props.new && (
                                            <IconButton
                                                onClick={() => {
                                                    this.props.goToLink(
                                                        `/pdf-viewer/method_statement/${profile.status}/${this.props.year}/${this.props.month}/${profile.job_id}/attached-files/${i}`
                                                    );
                                                }}
                                            >
                                                <ViewIcon />
                                            </IconButton>
                                        )}
                                        {!this.state.edit && (
                                            <IconButton
                                                onClick={() => {
                                                    this.setState({
                                                        signatureModal: {
                                                            index: i,
                                                            attached_signatures:
                                                                _.get(
                                                                    e,
                                                                    `attached_signatures`
                                                                ) || false,
                                                            file_name: e.file,
                                                        },
                                                    });
                                                }}
                                            >
                                                <DrawIcon />
                                            </IconButton>
                                        )}
                                        {this.state.edit && (
                                            <IconButton
                                                aria-label="Delete"
                                                onClick={() => {
                                                    let selFiles = profile.job_pack_method_statement.filter(
                                                        (f) => f.file !== e.file
                                                    );

                                                    this.props.callback(
                                                        "job_pack_method_statement",
                                                        selFiles
                                                    );
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })}
                </List>
                {edit && (
                    <Button
                        variant="contained"
                        style={{
                            width: "calc(100% - 48px)",
                            margin: 24,
                            position: "relative",
                            background: "#0188cc",
                            color: "white",
                        }}
                        onClick={() => this.setState({ addFileModal: true })}
                    >
                        Select/Upload Files
                    </Button>
                )}
                {this.state.addFileModal && (
                    <FileUploader
                        isOpen={this.state.addFileModal}
                        multipleUploads={true}
                        closeFileUploader={() =>
                            this.setState({ addFileModal: false })
                        }
                        callback={(files) => {
                            this.props.callback(
                                "job_pack_method_statement",
                                profile.job_pack_method_statement
                                    ? [
                                          ...profile.job_pack_method_statement,
                                          ...files,
                                      ]
                                    : files
                            );
                        }}
                    />
                )}

                <Modal isOpen={deleteModal ? true : false}>
                    <ModalHeader>Delete Method Statement</ModalHeader>
                    <ModalBody>
                        <Typography variant="h5">Warning!</Typography>
                        <Typography variant="body2">
                            Deleting this Method Statement will delete all
                            associated signatures and data!
                        </Typography>
                        <Typography variant="body2">
                            Are you sure you wish to proceed?
                        </Typography>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            variant="contained"
                            onClick={() =>
                                this.setState({ deleteModal: false })
                            }
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                profile.job_pack_method_statement.splice(
                                    deleteModal.index,
                                    1
                                );
                                let updateSelectedFiles = this.state.selectedFiles.filter(
                                    (e) => e !== deleteModal.index
                                );
                                this.setState({
                                    selectedFiles: updateSelectedFiles,
                                });
                                this.props.callback(
                                    "job_pack_method_statement",
                                    profile.job_pack_method_statement
                                );

                                this.setState({ deleteModal: false });
                            }}
                        >
                            Delete
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={signatureModal ? true : false}>
                    <SignaturePaper ref={(el) => (this.componentRef = el)}>
                        <ModalHeader>
                            Signatures for {signatureModal.file_name} Method
                            Statement
                        </ModalHeader>
                        <ModalBody>
                            <Grid container spacing={8}>
                                {signatureModal.attached_signatures &&
                                    signatureModal.attached_signatures.map(
                                        (signature, i) => {
                                            return (
                                                <Grid
                                                    key={i}
                                                    item
                                                    xs={4}
                                                    xl={4}
                                                    sm={4}
                                                >
                                                    <div>
                                                        <Typography variant="body2">
                                                            <b>Name: </b>
                                                            {
                                                                signature.signature_name
                                                            }
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            <b>Timestamp: </b>
                                                            {
                                                                signature.signature_timestamp
                                                            }
                                                        </Typography>
                                                        <img
                                                            src={
                                                                signature.signature_url ===
                                                                ("" ||
                                                                    undefined ||
                                                                    null)
                                                                    ? noSig
                                                                    : signature.signature_url
                                                            }
                                                            style={{
                                                                height: 100,
                                                            }}
                                                            alt={`Signature ${i}`}
                                                        />
                                                    </div>
                                                </Grid>
                                            );
                                        }
                                    )}
                            </Grid>
                            {!signatureModal.attached_signatures && (
                                <Typography variant="body2">
                                    <b>No Signatures Present</b>
                                </Typography>
                            )}
                        </ModalBody>
                        <ModalFooterForPrint>
                            <ReactToPrint
                                trigger={() => (
                                    <Button
                                        variant="contained"
                                        onClick={() =>
                                            this.setState({
                                                signatureModal: false,
                                            })
                                        }
                                    >
                                        Print
                                    </Button>
                                )}
                                content={() => this.componentRef}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                    this.setState({ signatureModal: false })
                                }
                            >
                                Close
                            </Button>
                        </ModalFooterForPrint>
                    </SignaturePaper>
                </Modal>
            </ComponentTemplate>
        );
    }
}

export default connect(
    (store, props) => {
        const { selectors } = props;
        const { selectMethodStatmentFiles } = selectors;
        return { files: selectMethodStatmentFiles(store) };
    },
    { getAllFiles, uploadFile, redirectTo, goToLink }
)(JobPackMethodStatement);
